import { ModalContext } from "app/app";
import { FieldInput } from "components/fieldInput";
import { commodityOptions } from "data";
import { Form, Formik } from "formik";
import { Fragment, useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import image from "./images/loader.gif";
import styles from "./styles.module.scss";

export function CommodityModal(props) {
  const { modal, setModal } = useContext(ModalContext);
  const [commodity, setCommodity] = useState("");
  const [loading, setLoading] = useState(false);

  const validation = Yup.object().shape({
    percentage: Yup.string()
      .matches(/\b([1-9]|[1-9][0-9]|100)\b/, "Invalid percentage")
      .required("You need to insert a percentage between 1 and 100"),
  });

  useEffect(() => {
    setCommodity("");
  }, []);

  return (
    <Fragment>
      {modal.name === "commodity_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Add Commodity</div>
              <div className={styles.line} />
              <Formik
                validationSchema={validation}
                enableReinitialize
                initialValues={{
                  commodity,
                  percentage: "",
                }}
                onSubmit={async (values, { setErrors }) => {
                  if (!commodity)
                    return setErrors({
                      commodity: "You need to select at least one commodity",
                    });
                  setLoading(true);

                  setModal({});
                  await modal.action(values);

                  setLoading(false);
                }}
              >
                {({
                  errors,
                  touched,
                  values,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={(e) => {
                        handleSubmit(e);
                      }}
                    >
                      <div
                        className={styles.fieldRow}
                        style={{ marginBottom: 20 }}
                      >
                        <FieldInput
                          id="commodity"
                          type="search_select"
                          label="Select your commodity"
                          options={commodityOptions}
                          handleChange={(event) => {
                            setCommodity(event.value);
                          }}
                          errors={errors.commodity}
                          touched={touched.commodity}
                          showErrors
                          required
                        />
                      </div>
                      <div
                        className={styles.fieldRow}
                        style={{ marginBottom: 20 }}
                      >
                        <FieldInput
                          id="percentage"
                          type="text"
                          label="What percent of your loads are this commodity?"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          errors={errors.percentage}
                          touched={touched.percentage}
                          showErrors
                          required
                        />
                      </div>
                    </Form>
                    <div className={styles.footer}>
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          style={
                            !loading
                              ? { cursor: "pointer" }
                              : { cursor: "default" }
                          }
                          onClick={!loading ? submitForm : null}
                        >
                          {loading ? (
                            <img
                              src={image}
                              alt="loading"
                              style={{ width: "25px" }}
                            />
                          ) : (
                            "Add commodity"
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
